import { useEffect } from 'react'

interface SEOConfig {
  title?: string
  description?: string
  keywords?: string
  ogTitle?: string
  ogDescription?: string
  ogImage?: string
  twitterCard?: string
  favicon?: string // Add favicon support
}

export const useSEO = (config: SEOConfig) => {
  useEffect(() => {
    // Update document title
    if (config.title) {
      document.title = config.title
    }

    // Update favicon
    if (config.favicon) {
      // Remove existing favicon
      const existingFavicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement
      if (existingFavicon) {
        existingFavicon.remove()
      }
      
      // Create new favicon
      const link = document.createElement('link')
      link.rel = 'icon'
      link.type = 'image/png'
      link.href = config.favicon
      document.head.appendChild(link)
    }

    // Update meta tags
    const updateMetaTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement
      if (!meta) {
        meta = document.createElement('meta')
        meta.name = name
        document.head.appendChild(meta)
      }
      meta.content = content
    }

    const updateMetaProperty = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement
      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute('property', property)
        document.head.appendChild(meta)
      }
      meta.content = content
    }

    // Basic meta tags
    if (config.description) {
      updateMetaTag('description', config.description)
    }
    if (config.keywords) {
      updateMetaTag('keywords', config.keywords)
    }

    // Open Graph meta tags
    if (config.ogTitle) {
      updateMetaProperty('og:title', config.ogTitle)
    } else if (config.title) {
      updateMetaProperty('og:title', config.title)
    }

    if (config.ogDescription) {
      updateMetaProperty('og:description', config.ogDescription)
    } else if (config.description) {
      updateMetaProperty('og:description', config.description)
    }

    if (config.ogImage) {
      updateMetaProperty('og:image', config.ogImage)
    }

    updateMetaProperty('og:type', 'website')

    // Twitter Card meta tags
    if (config.twitterCard) {
      updateMetaTag('twitter:card', config.twitterCard)
    } else {
      updateMetaTag('twitter:card', 'summary_large_image')
    }

    // Cleanup function
    return () => {
      // Optional: Could remove added meta tags on component unmount
      // For now, we'll leave them as they might be useful for navigation
    }
  }, [config])


} 